import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { DomainDpStatus, DomainDpStatusKL } from '../../../shared/domain/domain-dp-approval.model';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { AdStatsDomainsService } from '../../../shared/services/ad-stats-domains.service';
import { Domain } from '../../../shared/domain/domain.model';
import { AdsTxtStatusLabels } from '../../../shared/domain/adstxt-status.model';

@Component({
  selector: 'cm-site-dp-site-details-dialog',
  template: `
    <h1 mat-dialog-title>
      {{domain.url}} {{domain.dpsApprovedCount}}/{{domain.dpsCount}}
    </h1>
    <div mat-dialog-content class="p-0">
      <table class="w-100 mt-3">
        <tr>
          <th class="mat-column-demand-partner">Dp name</th>
          <th class="mat-column-status">Status</th>
          <th class="text-center">Ads.txt</th>
          <th>Status change</th>
          <th class="mat-column-submitted">Submitted</th>
        </tr>
        <tr *ngFor="let d of domain.dpApprovals">
          <td class="mat-column-demand-partner">{{d.id.demandPartner}}</td>
          <td class="mat-column-status">
            <mat-select [(ngModel)]="d.status">
              <mat-option *ngFor="let s of DomainDpStatusKL" [value]="s.key">{{s.label}}
              </mat-option>
            </mat-select>
          </td>
          <td class="text-center">
            <cm-adstxt-status-icon [status]="d.adsTxtStatus"></cm-adstxt-status-icon>
          </td>
          <td>
            {{d.lastUpdatedOn | date:'MM/dd/yyyy'}}
            <small class="d-block">{{d.lastUpdatedOn | date:'HH:mm'}}</small>
          </td>
          <td class="mat-column-submitted" >
            <mat-checkbox [(ngModel)]="d.submitted" [matTooltip]="d.submittedDate ? d.submittedDate : ''"></mat-checkbox>
          </td>
        </tr>
      </table>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-center">
      <button mat-raised-button color="warn" mat-dialog-close cdkFocusInitial>Cancel</button>
      <button mat-raised-button color="primary" (click)="update()">Update</button>
    </div>
  `,
  styles: [`
    table {
    }

    table th {
      font-size: 12px;
      padding: 10px 0;
      color: #888;
      font-weight: normal;
    }

    table th:last-of-type {
      /*width: 125px;*/
    }

    table tr {
      border-bottom: 1px solid #DDD;
    }

    table td {
      height: 3rem;
      font-size: 13px;
    }

    table td,
    table th {
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .mat-column-demand-partner {
      width: 120px;
    }

    .mat-column-submitted {
      width: 60px;
    }

    .mat-column-status {
      width: 120px;
    }
  `],
  host: {'class': 'mat-dialog-info'}
})
export class DpSiteDetailsDialogComponent {
  domain: Domain;
  DomainDpStatusKL = DomainDpStatusKL();
  AdsTxtStatusLabels = AdsTxtStatusLabels;

  constructor(public dialogRef: MatDialogRef<DpSiteDetailsDialogComponent>,
              private service: AdStatsDomainsService,
              private sbs: SnackBarService,
              private gss: GlobalSpinnerService,
              @Inject(MAT_DIALOG_DATA) public data: { submittedVisible: boolean, domain: Domain }) {

    //submittedVisible not used for now
    this.domain = data.domain;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  update() {
    this.gss.showLoader();
    this.service.siteApprovalUpdate(this.domain.dpApprovals).subscribe(next => {
      this.gss.hideLoader();
      this.sbs.success('Update successful');
      this.domain.dpApprovals = next;
      this.domain.dpsApprovedCount = this.domain.dpApprovals.filter(d => d.status === DomainDpStatus.APPROVED).length;
    }, () => {
      this.gss.hideLoader();
      this.sbs.error('Update failed..');
    });
  }

}
